module.exports = __webpack_public_path__ + "img/biblecalendar.a679b790.png";